export default __webpack_public_path__ + "static/media/investors.495ab0a1.mp3";